/* eslint-disable no-console */
import {Logger} from '@practicegenius/domain/src/common/logger';
import {isClient} from '@practicegenius/pg-ui/src/utils/environment';

const level = Object.freeze({
  debug: 'debug',
  info: 'info',
  warning: 'warning',
  error: 'error',
  critical: 'critical',
});

type Level = typeof level[keyof typeof level];

// TODO FLOW-TO-TS Perhaps a rollbar type can be imported from somewhere?
interface RollbarWindow extends Window {
  Rollbar?: Record<Level, (message: string, data: any) => void>;
}

const _window = isClient ? (window as RollbarWindow) : ({} as RollbarWindow);

const logger = (level: Level, message: string, data?: unknown) => {
  // only send error logs to rollbar
  if (_window.Rollbar && (level === 'error' || level === 'critical')) {
    _window.Rollbar[level](message, data);
  }

  if (process.env.NODE_ENV === 'development') {
    console.log(`[${level}]`, message, data);
  }
};

const log: Logger = {
  debug(message: string, data?: unknown) {
    logger(level.debug, message, data);
  },

  info(message: string, data?: unknown) {
    logger(level.info, message, data);
  },

  warning(message: string, data?: unknown) {
    logger(level.warning, message, data);
  },

  error(message: string, data?: unknown) {
    logger(level.error, message, data);
  },

  critical(message: string, data?: unknown) {
    logger(level.critical, message, data);
  },
};

export default log;
